import React, { Component } from 'react';
import autoBind from 'react-autobind';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { resultHasErrors } from 'utils/graphql-errors';
import axios from 'axios';
import { console } from 'window-or-global';
import { withRouter } from 'react-router';

class CodeReviewProof extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
    this.state = {
      codeTestAttempt: null,
    };
  }

  componentDidMount() {
    const uuid = window && window.location.pathname.replace('/code-test-attempt/', '');
    this.loadSubmission(uuid);
  }

  async loadSubmission(uuid) {
    const { client } = this.props;

    try {
      const result = await client.query({
        query: gql`
          query getCodeTestAttemptByUuid($uuid: String!) {
            getCodeTestAttemptByUuid(uuid: $uuid) {
              uuid
              files {
                name
                uuid
                token
              }
              description
            }
          }
        `,
        variables: {
          uuid,
        },
      });

      const { data, errors } = result;

      if (resultHasErrors({ errors })) {
        console.log(errors[0].message);
      } else {
        const { getCodeTestAttemptByUuid } = data;

        this.setState({
          codeTestAttempt: getCodeTestAttemptByUuid,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  downloadFile(file) {
    axios
      .get(`${process.env.REACT_APP_API_ROOT}download/${file.uuid}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        },
        responseType: 'blob',
      })
      .then(response => {
        const fileName = `${file.name}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      });
  }
  render() {
    const { codeTestAttempt } = this.state;
    return (
      <div style={{ margin: 'auto', width: '35%', marginBottom: '5%', marginTop: '5%' }}>
        <div>
          {codeTestAttempt && (
            <div
              style={{
                paddingBottom: '20px',
                color: '#111E6C',
                fontSize: '24px',
                fontWeight: '900',
                fontFamily: 'Neue Standard Medium',
                textAlign: 'center',
              }}
            >
              Submission details
            </div>
          )}

          {codeTestAttempt &&
            codeTestAttempt.files.map(file => (
              <div
                style={{
                  border: '3px solid #f9f9f9',
                  padding: '10px',
                }}
              >
                {file.name}{' '}
                <i
                  className="fa fa-download fa-lg"
                  style={{ float: 'right', cursor: 'pointer' }}
                  onClick={() => this.downloadFile(file)}
                />
              </div>
            ))}
        </div>
        {codeTestAttempt &&
          codeTestAttempt.description && (
            <div className="mt-3 mb-3">
              <div
                style={{
                  paddingTop: '10px',
                  paddingBottom: '25px',
                  color: '#111E6C',
                  fontSize: '24px',
                  fontWeight: '900',
                  fontFamily: 'Neue Standard Medium',
                  textAlign: 'center',
                }}
              >
                Description
              </div>

              {codeTestAttempt.description}

              <hr />
            </div>
          )}
      </div>
    );
  }
}

export default withRouter(withApollo(CodeReviewProof));



// WEBPACK FOOTER //
// ./src/ui/graphql/AdminProfilerCandidates/codeReviewProofPage.js